import React, {} from "react";
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MessageSourceModal = ({ meta }) => {

    const [t, ] = useTranslation('global');
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
        <div className="modal-item" onClick={handleOpen}>
            {meta.f}
            <span className="material-symbols-outlined source-item-icon">
                search
            </span>
        </div>
            
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="msg-source-modal-content">
                    <p><b>{t('fileName')}</b>: {meta.f} </p>
                    <p><b>{t('fileNumber')}</b>: {meta.n} </p>
                    <p><b>{t('filePage')}</b>: {meta.p} </p>
                    <p><b>{t('fileChunk')}</b>: {meta.c}</p>
                </div> 
            </Modal> 
        </>       
    );
}

export default MessageSourceModal;